//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadPosts, loadCategories, loadLocationCategories } from '../services/ajaxRequests';
import CommunityCard from './CommunityCard';
import FilterLocation from './FilterLocation';
export default {
  name: 'communities',
  components: {
    CommunityCard,
    FilterLocation
  },
  data() {
    return {
      isLoading: false,
      posts: [],
      categories: [],
      locations_categories: [],
      categoryFilter: [],
      categoryLocationFilter: '',
      loadedPosts: 0,
      postsPerPage: 8
    };
  },
  watch: {
    categoryFilter: 'resetLoadedPosts',
    categoryLocationFilter: 'resetLoadedPosts'
  },
  methods: {
    async fetchPosts() {
      this.posts = await loadPosts();
      this.resetLoadedPosts();
    },
    getThumbnail(post) {
      if (post && post._embedded && post._embedded['wp:featuredmedia']) {
        return post._embedded['wp:featuredmedia'][0].source_url;
      } else {
        return base.template_url + '/assets/images/coming-soon.png';
      }
    },
    loadMore() {
      this.loadedPosts += this.postsPerPage;
    },
    postCategoriesList(ids) {
      return this.categories.filter(item => ids.includes(item.id));
    },
    resetLoadedPosts() {
      this.loadedPosts = this.postsPerPage;
    },
    viewAll() {
      this.categoryFilter = [];
      this.categoryLocationFilter = '';
    },
    filterByGetParam() {
      let uri = window.location.href.split('?');
      if (uri.length == 2) {
        let vars = uri[1].split('&');
        let getVars = {};
        let tmp = '';
        vars.forEach(function (v) {
          tmp = v.split('=');
          if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
        });
        if (getVars.location) {
          this.categoryLocationFilter = getVars.location;
        }
      }
    }
  },
  computed: {
    getCategoriesList() {
      return this.categories;
    },
    getCategoriesLocationsList() {
      return [{
        id: 'all',
        name: 'Location'
      }, ...this.locations_categories];
    },
    postsList() {
      let posts = this.posts;
      if (this.categoryFilter.length) {
        posts = posts.filter(post => {
          for (let i = 0; i < post.community_category.length; i++) {
            if (this.categoryFilter.includes(post.community_category[i])) {
              return post;
            }
          }
        });
      }
      if (this.categoryLocationFilter) {
        posts = posts.filter(post => post.community_location.includes(+this.categoryLocationFilter));
      }
      return posts;
    },
    getPostsListPaged() {
      return this.postsList.slice(0, this.loadedPosts);
    }
  },
  async created() {
    this.categories = await loadCategories();
    this.locations_categories = await loadLocationCategories();
    await this.fetchPosts();
    this.isLoading = !this.isLoading;
    this.filterByGetParam();
  }
};